<template>
    <div>
        <div class="font-size-sm text-uppercase text-muted">
            <slot name="label"/>
        </div>
        <slot/>
    </div>
</template>

<script>
export default {}
</script>
